import MenuItems from "./MenuItems";
const chunkArray = (arr, size) => {
  const result = [];
  for (let i = 0; i < arr.length; i += size) {
    result.push(arr.slice(i, i + size));
  }
  return result;
};



const Dropdown = ({
  submenus = [],
  dropdown,
  depthLevel,
  handlehamburger,
  handleCategoryClick,
  isFromMore,
  isRTL,
}) => {
  depthLevel = depthLevel + 1;
  const isMoreSecondLevel = isFromMore && depthLevel > 1;
  const isSecondLevel = depthLevel > 1;
  const dropdownClass = depthLevel > 1 ? "dropdown-submenu" : "";
  const columns = chunkArray(submenus, 10);

  const getColumnImage = (column) => {
    return column?.[0]?.image || "";
  };

  return (
    <ul
      className={`
        dropdown
        ${dropdown ? "show" : ""}
        bg-white
        rounded-md
        mt-[-5px]
        p-2
        sm:top-10 top-[70%]
        ${isSecondLevel ? "more-submenu-right" : ""}
      `}
      style={{ direction: isRTL ? "rtl" : "ltr", ...(!isSecondLevel && isRTL && { left: "50%", transform: "translateX(-50%)" }), ...(isSecondLevel && isRTL && { left: "auto", right: "100%", transform: "none" }) }}
    >
      <div
        className={`
          grid
          grid-cols-1
          sm:grid-cols-${Math.min(columns.length, 4)}
          gap-x-2
          gap-y-2
          ${isMoreSecondLevel ? "min-w-[540px] justify-start" : "min-w-[714px] justify-between"}
          sm:min-w-[300px]
          p-6
          sm:p-0
          justify-between
        `}
      >
        {columns.map((column, colIndex) => {
          const columnImage = getColumnImage(column);

          return (
            <div
              key={colIndex}
              className={`p-2 ${
                isMoreSecondLevel
                  ? "flex gap-4 items-start"
                  : "flex justify-between"
              }`}
            >
              <div className="flex flex-col gap-3 p-2">
            {column.map((submenu, index) => (
              <MenuItems
                key={`${colIndex}-${index}`}
                handlehamburger={handlehamburger}
                items={submenu}
                depthLevel={depthLevel}
                handleCategoryClick={handleCategoryClick}
                isMoreItem={isFromMore}
                topLevelCount={submenu.productCount}
              />
            ))}
          </div>

              {columnImage && (
                <div
                  className={
                    isMoreSecondLevel
                      ? `
                        w-[180px]
                        shrink-0
                        p-3
                        rounded-xl
                        ml-auto
                        border
                        border-[#FAEBF0]
                        bg-[#FDF7F9]
                      `
                      : `
                    w-[30%]
                    sm:w-auto
                    h-fit
                    p-2
                    rounded-xl
                    ml-auto
                    border
                    border-[#FAEBF0]
                    bg-[#FDF7F9]
                      `
                  }
                >
                  <img
                    src={columnImage}
                    alt="category"
                    className={
                      isMoreSecondLevel
                        ? "w-full h-auto object-contain rounded-lg"
                        : "w-full h-[30%] object-cover rounded-lg"
                    }
                  />
                </div>
              )}
            </div>
          );
        })}
      </div>
    </ul>
  );
};

export default Dropdown;